export interface LocationByProcedure {
  name: string;
  id: number;

}
